exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simple-event-form .subcategory-tags {\n  margin: 3px -2px 0 -2px;\n  min-height: calc(1.42857143em + 10px);\n}\n.simple-event-form .status-well {\n  display: inline-block;\n  padding: 3px 5px;\n  margin: 2px;\n  background: rgba(221, 221, 221, 0.5);\n  border: 2px solid #bbbbbb;\n  border-radius: 3px;\n  color: #bbbbbb;\n  white-space: nowrap;\n  font-weight: 900;\n  cursor: default;\n}\n.simple-event-form .status-well i {\n  margin-left: 3px;\n}\n.simple-event-form .status-well i:hover {\n  color: #d3d3d3;\n}\n", ""]);

// exports
